import { usePlanSaleStartBeforeDate } from "@/components/features/items/edit/plan/_shared/ui/components/term/sale-start-before-date/hooks";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

export const useDayTripPlanSaleStartBeforeDate = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { saleStartBeforeDate } = viewModel;

	return usePlanSaleStartBeforeDate({
		saleStartBeforeDate,
		onSetViewModel,
	});
};
